export default __webpack_public_path__ + "static/media/about-hand-written-2.92b8f798.png";